// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .activity-canvas-settings {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/core/components/settings-dropdown/settings-dropdown.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR","sourcesContent":[":host {\n    .activity-canvas-settings {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
